<template>
    <div style="position:relative">
        <i class="el-icon-caret-left arra" style="left: 0;" @click="handlePreWeek()"></i>

        <table style="width: 90%;margin: 0 5%" cellspacing="0" cellpadding="0" class="el-date-table">
            <tbody>
            <tr>
                <th>一</th>
                <th>二</th>
                <th>三</th>
                <th>四</th>
                <th>五</th>
                <th>六</th>
                <th>日</th>
            </tr>
                <tr class="el-date-table__row">
                    <td v-for="item in dateData" class="available ">
                        <div>
                            <span  :class="{'circle':item.date===chosenDate}" @click="handleChooseDate(item.date)">{{item.day}}</span>
                        </div>
                    </td>
                </tr>
                <tr class="el-date-table__row">
                    <td v-for="item in dateData" class="notifyCircle">
                       <div v-if="item.status==='true'" class="active-circle"></div>
                       <div v-else ></div>
                    </td >
                </tr>
            </tbody>
        </table>

        <i class="el-icon-caret-right arra" style="right: 0;" @click="handleNextWeek()"></i>
    </div>
</template>

<script>
    import store from '@/store'
    export default {
        name: "Index",
        data(){
            return{
                today:this.$moment().format('YYYY-MM-DD'),
                startDate: this.$moment().week(this.$moment().week()).startOf('week').format('YYYY-MM-DD'),
                chosenDate:this.$moment().format('YYYY-MM-DD'),
                dates:[]
            }
        },
        props:{
          value: {}
        },
        computed: {
            dateData(){
                const daysArr =[];
                for (let i = 0; i < 7; i ++) {
                    let date=this.$moment(this.startDate).add(i, 'd').format('YYYY-MM-DD')
                    daysArr[i]={
                        'date':date,
                        'day':this.$moment(this.startDate).add(i, 'd').format('DD'),
                        'status':this.array_contain(this.dates,date)?'true':'false'
                    }
                }
                return daysArr;
            },
        },
        created() {
            this.handleToday();
        },
        methods:{
            handleToday(){
                this.$axios.get(store.state.server + '/educationalAdministration/workDate?start_date='+this.startDate
                    +'&end_date='+ this.$moment(this.startDate).add(6,'d').format('YYYY-MM-DD')
                    +'&'+localStorage.baseUrl).then((response) => {
                    if (response.data.status == 'success') {
                        this.dates= response.data.data.dates;
                    }
                })
            },
            handleChooseDate(date){
                this.chosenDate=date;
                this.$emit('input', date);
                this.$emit('change', date);
            },
            handlePreWeek(){
                this.startDate=this.$moment(this.startDate).subtract(7,'d').format('YYYY-MM-DD');
                this.handleToday();
            },
            handleNextWeek(){
                this.startDate=this.$moment(this.startDate).add(7,'d').format('YYYY-MM-DD');
                this.handleToday();
            },
            array_contain(array, obj){
                for (let i = 0; i < array.length; i++){
                    if (array[i] === obj)
                        return true;
                }
                return false;
            }
        }
    }
</script>

<style scoped lang="scss">
    .arra{
        &:hover{
            cursor: pointer;
        }
        position:absolute;
        color: #cdcdda;
        font-size: 20px;
        top: 33px
    }
    .available span:hover{
        background: aliceblue;
    }
    .circle{
        border: 1px solid #23375d;
        border-radius: 20%;
    }
    .active-circle{
         width: 8px;
         height: 8px;
         background: #d6d6d6;
         border-radius: 4px;
        position:absolute;
        top: 20%;
        left: 50%;
        transform: translate(-50%,-50%);
    }
    .notifyCircle{
        height: 10px;
        padding: 0;
        margin: 0;
    }
</style>
